import React, { Suspense } from 'react'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'

import { RevampedFaberCustomerDashboard } from './components'
export default function FaberOtpDashboard() {
  return (
    <>
      <Suspense fallback={<LayoutSkeleton />}>
        <RevampedFaberCustomerDashboard />
      </Suspense>
    </>
  )
}
